var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxOutlineMusicFilter2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#292D32",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 3.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h20c.41 0 .75.34.75.75s-.34.75-.75.75H2zM2 9.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h9c.41 0 .75.34.75.75s-.34.75-.75.75H2zM2 15.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h6c.41 0 .75.34.75.75s-.34.75-.75.75H2zM2 21.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h4c.41 0 .75.34.75.75s-.34.75-.75.75H2z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91 19.82c0-1.61 1.31-2.93 2.93-2.93s2.93 1.31 2.93 2.93-1.31 2.93-2.93 2.93c-1.61 0-2.93-1.31-2.93-2.93zm1.5.01a1.43 1.43 0 1 0 2.86 0 1.43 1.43 0 0 0-2.86 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.27 19.82v-8.77c0-1.21.72-2.16 1.89-2.47l4.35-1.19c.95-.26 1.77-.16 2.35.29.58.45.88 1.18.88 2.19v8.51c0 .41-.34.75-.75.75s-.75-.34-.75-.75V9.87c0-.5-.1-.85-.29-.99-.19-.15-.58-.16-1.05-.03l-4.35 1.19c-.29.08-.78.32-.78 1.03v8.77c0 .4-.34.73-.75.73s-.75-.34-.75-.75z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.89 18.37c0-1.61 1.31-2.93 2.93-2.93s2.93 1.31 2.93 2.93-1.31 2.93-2.93 2.93c-1.61 0-2.93-1.31-2.93-2.93zm1.5.01a1.43 1.43 0 1 0 2.86 0 1.43 1.43 0 0 0-2.86 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3 13.8a.75.75 0 0 1 .53-.92l7.98-2.18a.75.75 0 1 1 .39 1.45l-7.98 2.18c-.07.01-.14.02-.2.02-.33 0-.63-.22-.72-.55z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineMusicFilter2);
export default __webpack_public_path__ + "static/media/vuesax-outline-music-filter-2.e636e3a5b041541bd1f2f44badf1a980.svg";
export { ForwardRef as ReactComponent };